import Service from '../Service';

const resource = "countingbocespresentation/";

export default {

    pagination(obj, requestID) {
        console.log("filtres", obj);
        return Service.post(resource + "paginationC", obj, {
            params: { requestID: requestID }
        });
    },

}